import React, { useEffect, useState } from 'react'
import SuccessGif from './../assets/images/success-order.gif';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { PiArrowLeftBold } from "react-icons/pi";
import LOGO from './../assets/images/vyapar_logo.png';
import { ApisService } from '../app/core/apis.service';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import { connect } from 'react-redux';
import { UserData } from '../app/store/model/userdata';

interface Props {
    userState: UserData
}
const SuccessOrder = (props: Props) => {
    const navigation = useNavigate();
    const routerParams = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const businessName = queryParams.get("bu");
    const onClickNewOrder = () => {
        navigation(`/order-form/${routerParams.id}`);
    }
    useEffect(()=>{
        
        console.log(localStorage.getItem('userDetails'));
    },[]);

    const showHistory = () => {
        navigation(`/${routerParams.id}/order-history?bu=${businessName}`);
    }

    return (
        <>
        <div className='primary-background p-2 align-items-center d-flex justify-content-between'>
                <div ><div>Order Form for</div> <b style={{ fontSize: 24 }}>{businessName}</b></div>
                <div className='text-end'><img src={LOGO} alt="" height={60} /></div>
            </div>
        <div className='d-flex align-items-center justify-content-center order-screen-bg vh-100'>
            <div className='d-flex flex-column justify-content-center'>
                <div className='d-flex justify-content-center my-3'>
                    <img src={SuccessGif} alt="" className='' style={{ objectFit: "contain", maxWidth: "100%", height: '200px' }} />
                </div>
                <div className='text-success fs-3 text-center'>Thank you! Your order has been placed successfully.</div>
                <div className='text-center my-3 fs-14'>
                    <div><button className="mb-2 btn btn-primary primary-background border-0 py-2 box-shadow" onClick={onClickNewOrder}>New order</button></div>
                    <div><button className="mb-2 btn btn-primary primary-background border-0 py-2 box-shadow" onClick={showHistory}>Show Previous Orders</button></div>
                </div>
            </div>
        </div>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    userState: state.UserDataReducer
});

export default connect(mapStateToProps)(SuccessOrder);